export default __webpack_public_path__ + "static/media/003.337cdb4d.png";